import { theme } from '@frameio/vapor';
import {
  IconBuilding,
  IconFolderClosed,
  IconFolderLocked,
  IconProject,
  IconWorkspace,
} from '@frameio/vapor-icons';
import { useIsRestrictedFolder } from '../hooks/useIsRestrictedFolder';

const FolderIcon = ({ id }: { id?: string }) => {
  const isRestrictedFolder = useIsRestrictedFolder(id ?? '');
  const Icon = isRestrictedFolder ? IconFolderLocked : IconFolderClosed;

  return (
    <Icon
      color={theme.colors.icon.primary}
      data-testid="invite-folder-icon"
      size={24}
    />
  );
};

export const ResourceIcon = ({ id, type }: { type: string; id?: string }) => {
  switch (type) {
    case 'ACCOUNT':
      return (
        <IconBuilding
          color={theme.colors.icon.primary}
          data-testid="invite-account-icon"
          size={24}
        />
      );
    case 'FOLDER':
      return <FolderIcon id={id} />;
    case 'PROJECT':
      return (
        <IconProject
          color={theme.colors.icon.primary}
          data-testid="invite-project-icon"
          size={24}
        />
      );
    case 'WORKSPACE':
      return (
        <IconWorkspace
          color={theme.colors.icon.primary}
          data-testid="invite-workspace-icon"
          size={24}
        />
      );
    default:
      return null;
  }
};
